
<div>
  <b-button
    v-if="!inline && selectedFilters && selectedFilters.length > 0"
    size="sm"
    class="ml-2"
    variant="outline-secondary"
    @click="clearFilters"
  >
    <Icon icon="times" size="14" />
    {{ __('buttons.clear-filters') }}
  </b-button>

  <b-dropdown
    v-if="!inline"
    ref="dropdown"
    size="sm"
    variant="outline-primary"
    no-caret
    class="ml-2"
    :left="placement === 'left'"
    :right="placement === 'right'"
    menu-class="dropdown-menu-custom"
    @hide="handleDropdownHide"
    @hidden="handleDropdownHidden"
  >
    <template #button-content>
      <Icon icon="list-ui-alt" size="14" />
      {{ __('buttons.filter') }}
      <b-badge
        v-if="selectedFilters && selectedFilters.length > 0"
        variant="soft-primary"
        class="ml-1"
      >
        {{ selectedFilters.length }}
      </b-badge>
    </template>
    <b-dropdown-text class="filter-header">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ __('buttons.filter') }}</span>

        <b-button
          v-if="selectedFilters && selectedFilters.length > 0"
          size="sm"
          variant="outline-secondary"
          @click="clearFilters"
        >
          {{ __('buttons.clear-all') }}
        </b-button>
      </div>
    </b-dropdown-text>
    <b-dropdown-form style="min-width: 285px">
      <slot name="filters"></slot>
      <div>
        <b-button variant="primary" class="mr-2" size="sm" @click="onSave">
          <Icon icon="check" class="mr-2" size="14" />
          {{ __('buttons.apply') }}
        </b-button>

        <b-button variant="outline-secondary" size="sm" @click="onCancel">
          <Icon icon="times" class="mr-2" size="14" />
          {{ __('buttons.cancel') }}
        </b-button>
      </div>
    </b-dropdown-form>
  </b-dropdown>

  <div v-else class="inline-filters">
    <div class="d-flex align-items-center">
      <b-button
        v-if="inline && selectedFilters && selectedFilters.length > 0"
        size="sm"
        class="mr-2"
        variant="outline-secondary"
        @click="clearFilters"
      >
        <Icon icon="times" size="14" />
        {{ __('buttons.clear-filters') }}
      </b-button>

      <slot name="filters" :apply-filters="applyFilters" />

      <b-button variant="primary" class="ml-2" size="sm" @click="onSave">
        <Icon icon="check" class="mr-2" size="14" />
        {{ __('buttons.apply') }}
      </b-button>
    </div>
  </div>
</div>
